module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion_main"
  }, [_c('div', {
    staticClass: "accordion-wrap"
  }, [_c('div', {
    ref: "head",
    staticClass: "accordion-head",
    on: {
      "click": _vm.toggleOpen,
      "mouseenter": function($event) {
        !_vm.isTouch && _vm.toggleHover(1)
      },
      "mouseleave": function($event) {
        !_vm.isTouch && _vm.toggleHover(0)
      },
      "mousemove": function($event) {
        !_vm.isTouch && _vm.handlerMouseMove()
      }
    }
  }, [_c('div', {
    staticClass: "head-text"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.main_accordion_title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.main_accordion_excerpt)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow-wrap"
  }, [_c('div', {
    staticClass: "icon-holder"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "37.072",
      "height": "22.071",
      "viewBox": "0 0 37.072 22.071"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_7885",
      "data-name": "Path 7885",
      "d": "M8040.093,499.112l15-15-15-15",
      "transform": "translate(502.648 -8036.558) rotate(90)",
      "fill": "none",
      "stroke": "#000",
      "stroke-linecap": "round",
      "stroke-width": "5"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-hidden"
  }, [_c('div', {
    staticClass: "accordion-hidden-content"
  }, [_c('div', {
    staticClass: "accordion-hidden-image"
  }, [_c('CarouselProds', {
    attrs: {
      "indexActive": _vm.activeProd,
      "imagesArray": _vm.content.main_accordion_image,
      "canToggle": _vm.canToggle
    },
    on: {
      "update:canToggle": function($event) {
        _vm.canToggle = $event
      },
      "update:can-toggle": function($event) {
        _vm.canToggle = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "accordion-inner-accordions-wrap"
  }, _vm._l((_vm.content.main_accordion_rows), function(accordions, index) {
    return _c('AccordionInner', {
      key: index,
      attrs: {
        "data": _vm.content.main_accordion_rows[index],
        "activeProd": _vm.activeProd,
        "indexOrder": index,
        "canToggle": _vm.canToggle
      },
      on: {
        "update:activeProd": function($event) {
          _vm.activeProd = $event
        },
        "update:active-prod": function($event) {
          _vm.activeProd = $event
        }
      }
    })
  }), 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61153a5f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AccordionMain.vue
// module id = 363
// module chunks = 0